import React, { FC } from 'react';
import { View, Text, ViewStyle, TouchableOpacity } from 'react-native';
import styles, { getBackgroundColor, getTextColor } from './Message.styles';
import Icon from '../Icon/Icon';

export interface MessageProps {
  testID?: string;
  message: string;
  onClose?: () => void;
  icon?: string;
  type: 'positive' | 'neutral' | 'focus' | 'negative';
  containerStyle?: ViewStyle;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'positive':
      return 'UilCheckCircle';
    case 'negative':
      return 'UilExclamationTriangle';
    case 'neutral':
      return 'UilInfoCircle';
    default:
      return 'UilInfoCircle';
  }
};

const Message: FC<MessageProps> = ({
  testID,
  message,
  onClose,
  type,
  icon,
  containerStyle,
}) => {
  const hasAccessory = Boolean(onClose || icon);

  return (
    <View
      style={[
        styles.container,
        containerStyle,
        { backgroundColor: getBackgroundColor(type) },
      ]}
    >
      <View style={styles.rowCell}>
        {icon && (
          <View style={styles.iconContainer}>
            <Icon size={18} name={getIcon(type)} color={getTextColor(type)} />
          </View>
        )}
        <Text
          testID={testID}
          style={[
            styles.messageText,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              textAlign: hasAccessory ? 'left' : 'center',
              color: getTextColor(type),
            },
          ]}
        >
          {message}
        </Text>
      </View>
      {onClose ? (
        <TouchableOpacity style={styles.icon} onPress={onClose}>
          <Icon name="times-circle" size={20} color={getTextColor(type)} />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

export default Message;
